import {IResponse, OrderFilter, PageFilter} from "./api";
import {AxiosResponse} from "axios";
import {ColorFilter, FileDescriptor, TypeDownload, TypeUrl, WeightFilter} from "./categories";

export interface IGetProductsRequest {
	Categories: string[],
	//Name?: string,
	State: "Approved",
	PageFilter: PageFilter;
	OrderFilter: OrderFilter;
}

export interface IProduct {
	"IdProduct": string,//"43e09654-7d83-4abc-a71f-fc59e511840e", //Id in Fabric
	"Name": string, //Visual name of the product
	"Description": null, //Visual code of the product
	"PreviewImage": string, //url
	"PreviewReverse": string, //url
	"IconImage": string, //url
	//"No3D": false,
	//"EnableCloth": false,
	//"TileHeight": 5.0,
	//"TileWidth": 5.0,
	//"NoTile": false,
	"IdCategory": string,
	"BasesIds": string[], //Override to the category ids euro 2.0 Ids for products base, 1 expected, used to fetch textures with simulation call
	//"IsPrint": false

	Urls?: FileDescriptor<TypeUrl>[], //can override Category Urls
	Files?: FileDescriptor<TypeDownload>[], //can override Category Files
	IdReference: string //to select from param the variant
}

export interface ProductData extends IProduct{
	simulation?: IProductSimulation;
	techView?: IProductTechView;

	//resultTechview?: Promise<AxiosResponse<IResponse<IProductTechView>, any>>;

	//Base and override
	//baseProductResultSimulation? : Promise<AxiosResponse<IResponse<IProductSimulation>, any>>;
	//resultSimulation?: Promise<AxiosResponse<IResponse<IProductSimulation>, any>>
}

export interface IProductSimulation {
	"IdProduct": string, //"43e09654-7d83-4abc-a71f-fc59e511840e",
	"Name": string, //"01",
	"PreviewImage": string, //"https://fabric-senseir-dev.s3.amazonaws.com/0102e067-70db-4ac3-8992-be5d09513008/products/43e09654-7d83-4abc-a71f-fc59e511840e/main_img_lacework_raschel_24267351_MainTex_20210201140637764_20230411224049123.jpg",
	"AlbedoMap": string, //"https://fabric-senseir-dev.s3.amazonaws.com/0102e067-70db-4ac3-8992-be5d09513008/products/43e09654-7d83-4abc-a71f-fc59e511840e/image/lacework_raschel_24267351_MainTex_20210201140633363_20230411224050434.jpg",
	"OcclusionMap": string,
	"MetallicMap": string, //null,
	"NormalMap": string, //"https://fabric-senseir-dev.s3.amazonaws.com/0102e067-70db-4ac3-8992-be5d09513008/products/43e09654-7d83-4abc-a71f-fc59e511840e/image/lacework_raschel_46375002_BumpMap_20210201140635024_20230411224051602.jpg",
	"OpacityMap": string //,
	"SmoothnessMap": string //null,
	"ReverseMap": string,
	//"Geometry": null,
	//"EnableZoom": false,
	//"No3D": false,
	//"EnableCloth": false,
	"TileWidth": number, //5.0,
	"TileHeight": number, //5.0,
	"NoTile": boolean, //false,
	"AltTileWidth": number, //5.0, //Controlled usage from TileMode
	"AltTileHeight": number, //5.0, //Controlled usage from TileMode
	"TileMode": TileMode, //false,
	//"Proxie": null,
	//"Physics": { "MaxBending": 0.0, "Lift": 0.0, "Drag": 0.0, "Damping": 0.0 },
	//"NormalVal": 0.0,
	//"SmoothnessVal": 1.0,
	//"OcclusionVal": 0.0,
	//"OpacityVal": 1.0,
	//"MetallicVal": 0.0,
	//"EnableSpecular": false,
	//"EnableGlossiness": false,
	"IdCategory": string, //"9c769658-bd17-47fe-8d90-30e7424f9b34",
	//"BasesIds": [],
	//"IsPrint": false
}

export enum TileMode {
	None = "none",
	AlbedoOnly = "albedoOnly",
}

export interface IProductTechView {
	"IdProduct": "43e09654-7d83-4abc-a71f-fc59e511840e",
	"Name": string,
	"Description": string,
	"Code": string, //"COT 10% LYC 90%" Composition
	"Weight": string,//"200gr",
	"Width": string, //"150 cm", Height
	"TechProperties": (UniquePerformances | Features)[],
	"TechviewMap": string, //technical view with scale euro2024
}

export enum UniquePerformances {
	Breathability = "Breathability",
	NoPilling = "NoPilling",
	QuickDrying = "QuickDrying",
	SunBlock = "SunBlock",
	WaterProof = "WaterProof",
	WaterRepellent = "WaterRepellent",
	WrinkleFree = "WrinkleFree",

	Wicking = "Wicking",
}

export enum Features {
	EasyCare = "EasyCare",
	ExtraConfort = "ExtraConfort",
	ExtraFine = "ExtraFine",
	ChlorineResistance = "ChlorineResistance",

	BestSeller = "BestSeller",
	OdourFree = "OdourFree",
	Recycled = "Recycled",
	SoftTouch = "SoftTouch",

	//Grs = "Grs", //Missing image
	//Brushed = "Brushed", //Missing image
	//Neon = "Neon", //Missing image
}

export const UniquePerformancesKeyArray = Object.values(UniquePerformances).map(perf => perf.toString());
export const FeaturesKeyArray = Object.values(Features).map(perf => perf.toString());

export function UniquePerfToFile(uniquePerf: (UniquePerformances | Features)): string {
	const basePath = "/assets/UniquePerformances/";

	switch (uniquePerf) {
		case UniquePerformances.Breathability:
			return basePath + "Breathability.png";
		case UniquePerformances.NoPilling:
			return basePath + "NoPilling.png";
		case UniquePerformances.QuickDrying:
			return basePath + "QuickDrying.png";
		case UniquePerformances.SunBlock:
			return basePath + "SunBlock.png";
		case UniquePerformances.WaterProof:
			return basePath + "WaterProof.png";
		case UniquePerformances.WaterRepellent:
			return basePath + "WaterRepellent.png";
		case UniquePerformances.WrinkleFree:
			return basePath + "WrinkleFree.png";
		case UniquePerformances.Wicking:
			return basePath + "Wicking.png";


		case Features.ChlorineResistance:
			return basePath + "ChlorineResistance.png";
		case Features.EasyCare:
			return basePath + "EasyCare.png";
		case Features.ExtraConfort:
			return basePath + "ExtraConfort.png";
		case Features.ExtraFine:
			return basePath + "ExtraFine.png";
		case Features.BestSeller:
			return basePath + "Best_seller.png";
		case Features.OdourFree:
			return basePath + "Odour_free.png";
		case Features.Recycled:
			return basePath + "grs.png";
		case Features.SoftTouch:
			return basePath + "Soft_touch.png";

		default:
			return "";
	}
}

export type TechCode = "SPO" | "REA" | "SWI" | "UND";
export const TechCodeArray : TechCode[] = ["SPO", "REA", "SWI", "UND"];

export function ModelCodeToString(modelCode: string): string {
	switch (modelCode) {
		case "SPO":
			return "SPORTSWEAR";
		case "REA":
			return "READY TO WEAR";
		case "SWI":
			return "SWIMWEAR";
		case "UND":
			return "UNDERWEAR";
		default:
			return modelCode;
	}
}

export interface IGetProductNamesRequest {
	Name: string,
	"ColoursFilter": string[],
	PageFilter: PageFilter;
}